import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getSummary() {
        try {
            const response = await axios.get(`ProjectCharges/summary`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }catch(error){
            console.log('ProjectCharges api getSummary error')
            throw error
        }
    },
    async getWeeklySummary(fiscalPeriodId) {
        try {
            const response = await axios.get(`ProjectCharges/weekly-summary/${fiscalPeriodId}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }catch(error){
            console.log('ProjectCharges api getWeeklySummary error')
            throw error
        }
    },
    async getWeeklyDetails(data) {
        try {
            const response = await axios.get(`ProjectCharges/weekly/${data.fiscalYear}/${data.weekNo}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }catch(error){
            console.log('ProjectCharges api getWeeklyDetails error')
            throw error
        }
    },
    async getWeeklyDetailsByUser(data) {
        try {
            const response = await axios.get(`ProjectCharges/weekly/${data.fiscalYear}/${data.weekNo}/${data.userId}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }catch(error){
            console.log('ProjectCharges api getWeeklyDetailsByUser error')
            throw error
        }
    },
    async getWeeklyDetailsByTeam(data) {
        try {
            const response = await axios.get(`ProjectCharges/weekly/team/${store.state.selectedTeamId}/${data.fiscalYear}/${data.weekNo}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }catch(error){
            console.log('ProjectCharges api getWeeklyDetailsByTeam error')
            throw error
        }
    },
    //not used as right now project charges is by company
    //can be used in future enhancement if needed, but need to pass the selectedTeamId
    // async getSummaryByTeam() {
    //     try {
    //         const response = await axios.get(`ProjectCharges/summary/team`, {
    //             headers: {
    //                 'page_key': pageKeys.projectcharges
    //             }
    //         })            
    //         return response
    //     }catch(error){
    //         console.log('ProjectCharges api getSummaryByTeam error')
    //         throw error
    //     }
    // },
    async getByCutOffByUser(cutOffId) {
        try
        {            
            const response = await axios.get(`ProjectCharges/cutoff/${cutOffId}/user`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges getByCutOffByUser api error')
            throw error
        }
    },
    async forReviewAll(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/forreviewall`, 
            { 
                item: data 
            },
            {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api forReviewAll error')
            throw error
        }
    },
    async getByCutOffBySelectedUser(cutOffId, userId) {
        try
        {            
            //this is accessed by approver
            const response = await axios.get(`ProjectCharges/cutoff/${cutOffId}/user/${userId}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges getByCutOffBySelectedUser api error')
            throw error
        }
    },
    async getById(projectChargesId) {
        try
        {            
            const response = await axios.get(`ProjectCharges/${projectChargesId}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges getById error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/add`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                                  
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/update`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                                  
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api update error')
            throw error
        }
    },
    async weeklyBatchSave(data, fiscalYear, weekNo, userId) {
        try{            
            const response = await axios.post(`ProjectCharges/weekly/${fiscalYear}/${weekNo}/${userId}`, 
            {
                items: data
            }, 
            {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })
            return response
        }catch (error){
            console.log('ProjectCharges api weeklyBatchSave error')
            throw error
        }
    },
    async weeklyBatchForReview(data, fiscalYear, weekNo, userId) {
        try{            
            const response = await axios.post(`ProjectCharges/weekly/forreview/${fiscalYear}/${weekNo}/${userId}`, 
            {
                items: data
            }, 
            {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })
            return response
        }catch (error){
            console.log('ProjectCharges api weeklyBatchForReview error')
            throw error
        }
    },
    async weeklyBatchApprove(data, fiscalYear, weekNo, userId) {
        try{            
            const response = await axios.post(`ProjectCharges/weekly/approve/${fiscalYear}/${weekNo}/${userId}`, 
            {
                items: data
            }, 
            {
                headers: {
                    'page_key': pageKeys.projectcharges_approver
                }
            })                                  
            return response
        }catch (error){
            console.log('ProjectCharges api weeklyBatchApprove error')
            throw error
        }
    },
    async weeklyBatchReject(data, fiscalYear, weekNo, userId) {
        try{            
            const response = await axios.post(`ProjectCharges/weekly/reject/${fiscalYear}/${weekNo}/${userId}`, 
            {
                items: data
            }, 
            {
                headers: {
                    'page_key': pageKeys.projectcharges_approver
                }
            })                                  
            return response
        }catch (error){
            console.log('ProjectCharges api weeklyBatchReject error')
            throw error
        }
    },
    async forReview(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/forreview`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                                  
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api forReview error')
            throw error
        }
    },
    async delete(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/delete`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                                  
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api delete error')
            throw error
        }
    },
    async approve(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/approve`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges_approver
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api approve error')
            throw error
        }
    },
    async approveAll(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/approveall`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges_approver
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api approveall error')
            throw error
        }
    },    
    async reject(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/reject`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges_approver
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api reject error')
            throw error
        }
    },
    async rejectAll(data) {
        try
        {            
            const response = await axios.post(`ProjectCharges/rejectall`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projectcharges_approver
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api rejectAll error')
            throw error
        }
    },
    async getByUser(transDate) {
        try
        {            
            const response = await axios.get(`ProjectCharges/byuser/${transDate}`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges api getByUser error')
            throw error
        }
    },
    async getByCutOffByTeam(cutOffId) {
        try
        {            
            const response = await axios.get(`ProjectCharges/cutoff/${cutOffId}/team`, {
                headers: {
                    'page_key': pageKeys.projectcharges
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('ProjectCharges getByCutOffByTeam api error')
            throw error
        }
    },
}